/**
 * Slice Constants
 */
export const SLICE_ACCOUNT_CREATION = "accountCreation";
export const SLICE_PROVIDER_ACCOUNT_CREATION = "providerAccountCreation";
export const SLICE_LINK_APPLICATION = "linkApplication";
export const SLICE_MY_PROFILE = "myProfile";
export const SLICE_LOGIN = "login";
export const SLICE_TIME_SHIFTER = "timeShifter";
export const SLICE_AUTHORIZATION = "authorization";
export const SLICE_REFERENCE_DATA = "referenceData";
export const SLICE_PROVIDER_REQUESTS = "providerRequests";

/**
 * Thunk Constants
 */
export const THUNK_POST_VERIFICATION_METHOD = "postVerificationMethod";
export const THUNK_POST_USERNAME = "postUsername";
export const THUNK_POST_PASSWORD = "postPassword";
export const THUNK_POST_ACCOUNT = "postAccount";
export const THUNK_POST_CREATE_ACCOUNT = "postCreateAccount";
export const THUNK_POST_OTP = "postOTP";
export const THUNK_POST_VALIDATE_OTP = "postValidateOTP";
export const THUNK_POST_VERIFY_PROVIDER_DETAILS = "postVerifyProviderDetails";
export const THUNK_GET_PROVIDER = "getProvider";
export const THUNK_GET_PROVIDER_LOCATION = "getProviderLocation";
export const THUNK_POST_PROVIDER_USERNAME = "postProviderUsername";
export const THUNK_POST_PROVIDER_PASSWORD = "postProviderPassword";
export const THUNK_POST_PROVIDER_OTP = "postProviderOTP";
export const THUNK_POST_PROVIDER_RESEND_OTP = "postProviderResendOTP";
export const THUNK_POST_PROVIDER_VALIDATE_OTP = "postProviderValidateOTP";
export const THUNK_POST_PROVIDER_CREATE_ACCOUNT = "postProviderCreateAccount";
export const THUNK_POST_LINK_APPLICATION = "postLinkApplication";
export const THUNK_POST_SEARCH_LINK_APPLICATION = "postSearchLinkApplication";
export const THUNK_POST_FORGOT_USERNAME = "postForgotUsername";
export const THUNK_POST_FORGOT_PASSWORD = "postForgotPassword";
export const THUNK_POST_NEW_PASSWORD = "postNewPassword";
export const THUNK_POST_RESET_FORGOT_PASSWORD = "postResetForgotPassword";
export const THUNK_POST_RESET_PASSWORD = "postResetPassword";
export const THUNK_PUT_NAME = "putName";
export const THUNK_GET_VERIFICATION_METHODS = "getVerificationMethods";
export const THUNK_PUT_ACCOUNT = "putAccount";
export const THUNK_POST_SEND_OTP = "postSendOTP";
export const THUNK_POST_LOGIN_VALIDATE_OTP = "postLoginValidateOTP";
export const THUNK_POST_AUTHENTICATE = "postAuthenticate";
export const THUNK_POST_IDENTIFY_USER = "postIdentifyUser";
export const THUNK_POST_REMOVE_VERIFICATION_METHOD =
  "postRemoveVerificationMethod";
export const THUNK_POST_REGISTER_EDIT_VERIFICATION_METHOD =
  "postRegisterEditVerificationMethod";
export const THUNK_GET_ACCOUNT_DETAILS = "getAccountDetails";
export const THUNK_POST_REFRESH_JWT_TOKEN = "generateToken";
export const THUNK_GET_PERFORM_LOGOUT = "performLogout";
export const THUNK_GET_MY_PROFILE = "getMyProfile";
export const THUNK_TIME_SHIFTER_OFFSET = "timeShifterOffset";
export const THUNK_MY_PROFILE_ADD_EDIT_VERIFICATION =
  "myProfileAddEditVerification";
export const THUNK_PUT_RESET_MY_PROFILE_PASSWORD = "putResetMyProfilePassword";

export const THUNK_POST_NEW_PASSWORD_MY_PROFILE = "postNewPasswordMyProfile";
export const THUNK_PUT_SELF_ENABLE = "putSelfEnable";
export const THUNK_PUT_VERIFICATION_METHOD = "putVerificationMethod";
export const THUNK_GET_DASHBOARD_DETAILS = "getDashboardDetails";
export const THUNK_GET_ASSOCIATED_LOCATIONS = "getAssociatedLocations";
export const THUNK_POST_PROVIDER_MESSAGE_CENTER = "postProviderMessageCenter";

export const THUNK_PUT_ACCOUNT_NAME_SETTINGS = "putAccountNameSettings";
export const THUNK_POST_MESSAGE_CENTER_INBOX = "postMessageCenterInbox";

export const THUNK_GET_REFERENCE_DATA = "fetchReferenceData";
export const THUNK_GET_PROVIDER_REQUESTS = "getProviderRequests";

/*API Response statuses */
export const API_STATUS_IDLE = "idle";
export const API_STATUS_SUCCESS = "success";
export const API_STATUS_LOADING = "loading";
export const API_STATUS_FAILURE = "failure";

/*Builder Types*/
export const BUILDER_TYPE_PENDING = "pending";
export const BUILDER_TYPE_FULFILLED = "fulfilled";
export const BUILDER_TYPE_REJECTED = "rejected";

/**
 * API call initial response
 */
export const API_INITIAL_STATE = {
  status: API_STATUS_IDLE,
  message: null,
  error: null,
  correlationId: null,
  timestamp: null,
};
